export const parseJson = (jsonString) => {
    const result = {
        success: false,
        data: null,
        error: null,
        isEmpty: false
    }
    if (!jsonString || jsonString.trim() === '') {
        result.isEmpty = true;
        result.success = true; // Empty is considered "successful"
        return result;
    }
    try {
        result.data = JSON.parse(jsonString)
        result.success = true;
    }
    catch (e) {
        result.success = false
        result.data = null
        result.error = e
    }
    return result
}
export const isValidWorkflowName = (name) => {
    return name &&
        name !== 'undefined' &&
        name !== 'null' &&
        name !== undefined &&
        name !== null;
};
